import {DATA_TYPES} from '../../constants/constants'

export const VARIABLES_LIST_TYPE = 'VariablesList'

export const NAMESPACES_SUPPORTING_VARIABLES = new Set([DATA_TYPES.layout, DATA_TYPES.theme, DATA_TYPES.variables])
